<template>
  <div class="liquor-daily">
    <div class="left">
      <multi-media
        :list="util.getFileList(item.multimedia)"
        :width="640"
        :height="440"
        controls
        v-if="item.multimedia"
      />
      <img src="/liquor/每日一醉背景.jpg" v-else />
    </div>
    <div class="right">
      <div class="logo">
        <img src="/liquor/每日一醉.png" alt="每日一醉" />
      </div>
      <div class="title">{{item.title}}</div>
      <div class="content">{{item.content}}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Daily",
  data() {
    return {
      dayTime: 1000 * 60 * 60 * 24,
      item: {
        title: "",
        content: "",
        multimedia: ""
      }
    };
  },
  created() {
    this.init();
  },
  methods: {
    async init() {
      const response = await this.ajax.doPost({
        packageName: "liquor",
        className: "liquorDaily",
        methodName: "retrieve",
        params: {}
      });

      const now = Date.now();

      const latest = response.results.find(e => {
        return (
          parseInt((e.updateTime || e.createTime) / this.dayTime) ===
          parseInt(now / this.dayTime)
        );
      });

      if (latest) {
        this.item = latest;
        console.log(latest);
      } else {
        const mod = parseInt(now / this.dayTime) % response.results.length;

        this.item = response.results[mod];
      }
    }
  }
};
</script>

<style lang="scss">
.liquor-daily {
  width: 1100px;

  margin: 100px auto;

  .left {
    display: inline-block;
    vertical-align: top;

    width: 640px;
    height: 440px;

    img {
      width: 100%;
    }
  }

  .right {
    display: inline-block;
    vertical-align: top;

    width: 380px;
    height: 360px;
    padding: 40px;
    background: rgba(0, 0, 0, 1);

    .logo {
      height: 32px;

      img {
        height: 32px;
      }
    }

    .title {
      margin-top: 20px;
      font-size: 32px;
      font-family: "FZQKBYSJW";
      font-weight: normal;
      color: rgba(228, 200, 150, 1);
      line-height: 36px;
    }

    .content {
      margin-top: 30px;
      font-size: 16px;
      font-weight: 400;
      color: rgba(191, 191, 191, 1);
      line-height: 30px;
    }
  }
}
</style>